import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import GiftListPage from './pages/GiftListPage';
import CoupleDashboard from './pages/CoupleDashboard';
import AdminPanel from './pages/AdminPanel';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import ComoRegalarPage from './pages/ComoRegalarPage';
import FormasDePagoPage from './pages/FormasDePagoPage';
import PublicGiftList from './pages/PublicGiftList';
import SearchResultsPage from './pages/Searchresultspage';
import ExplorePage from './pages/ExplorePage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* <Route path="/lista/:coupleId" element={<GiftListPage />} /> */}
          <Route path="/buscar" element={<Navigate to="/" replace />} />
                    <Route path="/buscar-resultados" element={<SearchResultsPage />} /> {/* ← AGREGAR ACÁ */}
<Route path="/explorar" element={<ExplorePage />} />

          <Route path="/lista/:coupleId" element={<PublicGiftList />} />
          {/* Help Pages */}
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/como-regalar" element={<ComoRegalarPage />} />
          <Route path="/formas-de-pago" element={<FormasDePagoPage />} />
          
          {/* Protected Routes - Couples */}
          <Route 
            path="/mi-cuenta" 
            element={
              <ProtectedRoute>
                <CoupleDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Routes - Admin Only */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
